"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var actionCreators_1 = require("../../actionCreators");
var defaultOptions_1 = __importDefault(require("../../defaultOptions"));
var HeaderFilterButton = function (_a) {
    var column = _a.column, dispatch = _a.dispatch;
    var _b;
    return (React.createElement("span", { onClick: function (event) {
            event.stopPropagation();
            dispatch(actionCreators_1.updateHeaderFilterPopupState(column.key, !column.isHeaderFilterPopupShown));
        }, className: defaultOptions_1.default.css.iconFilter + " ka-header-filter-button " + (((_b = column.headerFilterValues) === null || _b === void 0 ? void 0 : _b.length) ? 'ka-header-filter-button-has-value' : '') }));
};
exports.default = HeaderFilterButton;
